export default "__VITE_ASSET__DeQTnkAE__"